import TYPES from '../../types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';
import { CustomerOverviewEntity } from '../../domain/entities/customer-overview-entity';
import { CustomerOverviewRepository } from '../../domain/repositories/customer-overview-repository';
import { CustomerOverviewStateManager } from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state-manager';

@Injectable()
export default class GetCustomerOverviewQuery extends Query<Promise<CustomerOverviewEntity>> {
  @Inject(TYPES.CUSTOMER_OVERVIEW_REPOSITORY)
  private readonly repository!: CustomerOverviewRepository;

  @Inject(TYPES.CUSTOMER_OVERVIEW_STATE_MANAGER)
  private readonly state_manager!: CustomerOverviewStateManager;

  internalExecute(): Promise<CustomerOverviewEntity> {
    this.state_manager.patch({ is_loading: true });
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.get_customer_overview()
          .then((item) => {
            this.state_manager.patch({ item, loaded: true });
            resolve(item);
          })
          .catch(reject)
          .finally(() => {
            this.state_manager.patch({ is_loading: false });
          });
      } else {
        resolve(this.state_manager.state.item);
        this.state_manager.patch({ is_loading: false });
      }
    });
  }
}
